// Cliente GraphQL usando fetch nativo para máxima compatibilidad
interface GraphQLResponse<T = any> {
	data?: T
	errors?: Array<{
		message: string
		locations?: Array<{ line: number; column: number }>
		path?: string[]
	}>
}

// Configuración del cliente GraphQL
const createGraphQLClient = (endpoint: string, headers?: Record<string, string>) => {
	return {
		async request<T = any>(query: string, variables?: Record<string, any>): Promise<T> {
			try {
				const response = await fetch(endpoint, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						...headers
					},
					body: JSON.stringify({
						query,
						variables
					}),
					// Configuración para mejor debugging
					signal: AbortSignal.timeout(10000) // 10 segundos timeout
				})

				if (!response.ok) {
					throw new Error(`GraphQL request failed: ${response.status} ${response.statusText}`)
				}

				const result: GraphQLResponse<T> = await response.json()

				// Manejar errores de GraphQL
				if (result.errors && result.errors.length > 0) {
					const errorMessages = result.errors.map(error => error.message).join(', ')
					throw new Error(`GraphQL errors: ${errorMessages}`)
				}

				return result.data as T
			} catch (error) {
				console.error('GraphQL request error:', error)
				throw error
			}
		}
	}
}

// Cliente para Contentful
export const contentfulClient = createGraphQLClient(process.env.REACT_APP_API_GRAPH as string, {
	Authorization: `Bearer ${process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN}`
})

// Cliente genérico para otros endpoints
export const createClient = (endpoint: string, headers?: Record<string, string>) => {
	return createGraphQLClient(endpoint, headers)
}

export default contentfulClient
